// Content-Bilder liegen seit der PocketBase-Ablösung statisch unter public/content/
// (gleiches Pfadschema wie vorher: <collection>/<recordId>/<datei>)
export const IMAGES_BACKEND_URL = '/content/'
